import { useState, useEffect } from 'react';
import { useAuth0 } from '../components/auth/DevAuth0Provider';

/**
 * Custom hook to manage authentication loading states
 * Handles different phases of Auth0 Universal Login process
 */
export const useAuthLoadingStates = () => {
  const { isLoading, isAuthenticated } = useAuth0();
  const [authPhase, setAuthPhase] = useState('idle');
  const [loadingMessage, setLoadingMessage] = useState('');

  useEffect(() => {
    // Check if we're handling an Auth0 callback
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (error) {
      setAuthPhase('error');
      setLoadingMessage('Authentication failed');
    } else if (code) {
      setAuthPhase('callback');
      setLoadingMessage('Processing authentication');
    } else if (isLoading) {
      setAuthPhase('initializing');
      setLoadingMessage('Initializing authentication');
    } else if (isAuthenticated) {
      setAuthPhase('authenticated');
      setLoadingMessage('Authentication successful');
    } else {
      setAuthPhase('idle');
      setLoadingMessage('');
    }
  }, [isLoading, isAuthenticated]);

  // Determine if loading overlay should be visible
  const isAuthLoading = authPhase === 'initializing' || 
                       authPhase === 'callback' || 
                       (authPhase === 'authenticated' && isLoading);

  return {
    isAuthLoading,
    authPhase,
    loadingMessage,
    isInitializing: authPhase === 'initializing',
    isProcessingCallback: authPhase === 'callback',
    isAuthenticated: authPhase === 'authenticated',
    hasError: authPhase === 'error'
  };
};

export default useAuthLoadingStates;
